import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubDomainSelect]'})
export class DomainSelectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
